import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = ({ customItems = null, showOnHome = false }) => {
  const location = useLocation();

  // Ne pas afficher sur la page d'accueil sauf si explicitement demandé
  if (location.pathname === "/" && !showOnHome) {
    return null;
  }

  // Si des items personnalisés sont fournis, les utiliser
  if (customItems) {
    return (
      <nav aria-label="breadcrumb" className="bg-light py-2 breadcrumb-wrapper">
        <div className="container">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Accueil</Link>
            </li>
            {customItems.map((item, index) => (
              <li 
                key={index}
                className={`breadcrumb-item ${item.active ? 'active' : ''}`}
                aria-current={item.active ? 'page' : undefined}
              >
                {item.active ? (
                  item.label
                ) : (
                  <Link to={item.href}>{item.label}</Link>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    );
  }

  // Génération automatique basée sur l'URL
  const getBreadcrumbItems = () => {
    const items = [
      { href: "/", label: "Accueil", active: false }
    ];

    if (location.pathname.includes("/category")) {
      items.push({ href: "/category", label: "Nos box", active: true });
    }

    if (location.pathname.includes("/product/")) {
      items.push({ href: "/category", label: "Nos box", active: false });
      items.push({ href: "#", label: "Détails du produit", active: true });
    }

    if (location.pathname === "/login") {
      items.push({ href: "#", label: "Connexion", active: true });
    }

    if (location.pathname === "/register") {
      items.push({ href: "#", label: "Inscription", active: true });
    }

    if (location.pathname === "/cart") {
      items.push({ href: "#", label: "Panier", active: true });
    }

    if (location.pathname === "/checkout") {
      items.push({ href: "/cart", label: "Panier", active: false });
      items.push({ href: "#", label: "Commande", active: true });
    }

    if (location.pathname === "/about") {
      items.push({ href: "#", label: "À propos", active: true });
    }

    if (location.pathname === "/contact") {
      items.push({ href: "#", label: "Contact", active: true });
    }

    if (location.pathname === "/how-it-works") {
      items.push({ href: "#", label: "Comment ça marche", active: true });
    }

    if (location.pathname === "/profile") {
      items.push({ href: "#", label: "Mon profil", active: true });
    }

    if (location.pathname === "/orders") {
      items.push({ href: "#", label: "Mes commandes", active: true });
    }

    if (location.pathname === "/favorites") {
      items.push({ href: "#", label: "Mes favoris", active: true });
    }

    if (location.pathname === "/admin") {
      items.push({ href: "#", label: "Administration", active: true });
    }

    if (location.pathname === "/privacy-policy") {
      items.push({ href: "#", label: "Politique de confidentialité", active: true });
    }

    if (location.pathname === "/terms-of-service") {
      items.push({ href: "#", label: "Conditions d'utilisation", active: true });
    }

    if (location.pathname === "/legal-notice") {
      items.push({ href: "#", label: "Mentions légales", active: true });
    }

    return items;
  };

  const breadcrumbItems = getBreadcrumbItems();

  // Ne pas afficher si seulement l'accueil
  if (breadcrumbItems.length <= 1) {
    return null;
  }

  return (
    <nav aria-label="breadcrumb" className="bg-light py-2 breadcrumb-wrapper">
      <div className="container">
        <ol className="breadcrumb mb-0">
          {breadcrumbItems.map((item, index) => (
            <li 
              key={index}
              className={`breadcrumb-item ${item.active ? 'active' : ''}`}
              aria-current={item.active ? 'page' : undefined}
            >
              {item.active ? (
                item.label
              ) : (
                <Link to={item.href}>{item.label}</Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;